
import { defineComponent, reactive, ref, UnwrapRef, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import Axios from '../../../axios-vendor'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useStore } from "vuex";

interface FormState {
  current_password: string;
  password: string;
  password_confirmation: string;
}

export default defineComponent({
  components: {
    
  },
  setup () {
    const router = useRouter()
    const api = process.env.VUE_APP_BASEURL
    const loading = ref(false)
    const store = useStore();


    const userState: UnwrapRef<FormState> = reactive({
      current_password: '',
      password: '',
      password_confirmation: '',
    })

    const forgotPassword = () => {
      router.push('/forgot-password')
    }

    const handleFinish = async (values: FormState) => {
        store.dispatch('AuthVendor/updatePassword', userState).then(()=>{
            router.push('/dashboard')
        }).catch((e) => {
            Swal.fire({
            icon: 'error',
            title: 'Incorrect password',
            })
        })
    }
    return {
      loading,
      userState,
      handleFinish,
    }
  },
})
